module.exports = __webpack_public_path__ + "static/img/img_banner_2x.20d310c.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/img_banner_2x.png
// module id = T8Uv
// module chunks = 83